// Plural forms, per language, from the platform's own CLDR data.
//
// The previous approach hard-coded the Czech rule (1 / 2-4 / 5+) and applied it
// to every language. That is wrong in ways that show: German took a dative for
// 5+ ("5 Versuchen" instead of "5 Versuche"), and Polish sends 22-24 back to the
// "few" form while 12-14 take "many" — a plain 2..4 comparison can't express it.
//
// Intl.PluralRules knows each language's categories, so we ask it and look up the
// matching key. Missing categories fall back to "other", which is the one form
// every language defines.

const CATEGORIES = ["one", "few", "many", "other"];

// Cache: constructing a PluralRules per render is measurable in a long list.
const rulesByLang = new Map();

function rulesFor(lang) {
  const key = lang || "cs";
  if (!rulesByLang.has(key)) {
    // An unrecognised tag does NOT throw — Intl quietly falls back to the root
    // locale, whose rules are English-like and would silently un-decline every
    // Slavic count. Ask first, and fall back to the game's home language.
    let resolved = key;
    try {
      if (Intl.PluralRules.supportedLocalesOf(key).length === 0) resolved = "cs";
    } catch (e) {
      resolved = "cs"; // structurally invalid tag
    }
    rulesByLang.set(key, new Intl.PluralRules(resolved));
  }
  return rulesByLang.get(key);
}

export function pluralCategory(lang, n) {
  const num = Number(n);
  if (!Number.isFinite(num)) return "other";
  return rulesFor(lang).select(num);
}

// `stem` is a key prefix: "plural.attempt" → "plural.attempt.one" etc.
export function pluralize(t, lang, stem, n) {
  const category = pluralCategory(lang, n);
  const key = `${stem}.${category}`;
  const value = t(key);
  // i18next echoes the key back when it is missing; fall through to "other".
  if (value === key && category !== "other") return t(`${stem}.other`);
  return value;
}

export { CATEGORIES };
